import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

import { AiCropSize } from '../components/ai-crop-size/AiCropSize';
import { Header } from '../components/ai-crop-size/Header';
import { HideNotice } from '../components/ai-crop-size/HideNotice';
import { SizeControl } from '../components/ai-crop-size/SizeControl';
import { useLegacyAiCropSizeService } from '../services/useLegacyAiCropSizeService';

export const LegacyAiCropSizeContainer = () => {
  const {
    hideAiCropSizeInfo,
    aiCropSizeImageList,
    isEditRequested,
    handleZoom,
    handleEditRequest,
    aiImageRef,
    requestEditButtonRef,
  } = useLegacyAiCropSizeService();

  if (hideAiCropSizeInfo) {
    return <HideNotice />;
  }

  return (
    <Container>
      <Header />
      <AiCropSize imageList={aiCropSizeImageList} setAiImageRef={aiImageRef} />
      <SizeControl
        isEditRequested={isEditRequested}
        onClickZoom={handleZoom}
        onEditRequest={handleEditRequest}
        setRequestEditButtonRef={requestEditButtonRef}
      />
    </Container>
  );
};

export const Container = styled.div`
  margin-bottom: 240px;
  background-color: ${vars.color.staticWhite};
`;
